import { useDataProvider, useRefresh } from "ra-core";
import { useEffect } from "react";

import type { NevoraDataProvider } from "./dataProvider";

let yaRevisado = false;

/**
 * Al abrir la app, devuelve a Seguimiento las fichas de Largo plazo cuya fecha de vuelta
 * ya ha llegado (SPEC.md §2). Complementa al pg_cron diario: si el cron no corrió, la
 * vuelta se hace igualmente en cuanto alguien entra. Una vez por carga de página.
 */
export const RevisorLargoPlazo = () => {
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const refresh = useRefresh();

  useEffect(() => {
    if (yaRevisado) return;
    yaRevisado = true;
    dataProvider
      .revisarLargoPlazo()
      .then((n) => {
        if (n > 0) refresh();
      })
      .catch(() => {
        // sin conexión o sin permisos: no es crítico
      });
  }, [dataProvider, refresh]);

  return null;
};
